/**
 * Verifica se o desvio é obrigatório baseado nas regras de negócio:
 * - Valor absoluto do desvio > R$ 50.000,00 E
 * - Percentual do desvio > 5%
 */
export const isDeviationMandatory = (deviationValue: number, deviationPercentage: number): boolean => {
  const absValue = Math.abs(deviationValue)
  const absPercentage = Math.abs(deviationPercentage)
  
  return absValue > 50000 && absPercentage > 5
}

/**
 * Verifica se há algum desvio na linha (vs Budget ou vs S-1)
 */
export const hasDeviation = (deviationVsBudget?: number, deviationVsWeek?: number): boolean => {
  return (deviationVsBudget !== undefined && deviationVsBudget !== 0) || 
         (deviationVsWeek !== undefined && deviationVsWeek !== 0)
}

/**
 * Retorna a polaridade do desvio (positivo ou negativo)
 */
export const getDeviationPolarity = (deviationValue: number): 'positive' | 'negative' => {
  return deviationValue >= 0 ? 'positive' : 'negative'
}
